export default __webpack_public_path__ + "static/media/ico-aviao.a46828f2.svg";